import styled from 'styled-components';
import { colorRed, colorWhite, mediaQueryTabletMin } from 'styleUtils';
import Icon from 'components/Icon';
export var Links = /*#__PURE__*/styled.ul.withConfig({
  componentId: "sc-1f7u8ig-0"
})(["display:flex;justify-content:space-between;flex-wrap:nowrap;padding:16px 0;overflow-y:scroll;::-webkit-scrollbar{display:none;}@media ", "{display:inline-flex;overflow-y:inherit;max-width:976px;}"], mediaQueryTabletMin);
export var LinkIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-1f7u8ig-1"
})(["margin-left:4px;transition:transform 0.3s ease;"]);
export var Select = /*#__PURE__*/styled.li.withConfig({
  componentId: "sc-1f7u8ig-2"
})(["display:inline-flex;position:relative;", ""], function (_ref) {
  var open = _ref.open;

  if (open) {
    return "\n      & > button {\n        color: ".concat(colorRed, ";\n      }\n      & > button > svg {\n        transform: rotateZ(180deg);\n      }\n      ");
  }

  return '';
});
export var HiddenList = /*#__PURE__*/styled.ul.withConfig({
  componentId: "sc-1f7u8ig-3"
})(["background-color:", ";display:", ";border:1px solid #e3e3e3;right:0;top:100%;position:absolute;z-index:5;overflow-y:auto;padding:0;"], colorWhite, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? 'block' : 'none';
});